var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7157 32.5174H5.28409C4.84132 32.5174 4.48242 32.1585 4.48242 31.7158V5.28421C4.48242 4.84144 4.84132 4.48254 5.28409 4.48254H31.7157C32.1584 4.48254 32.5173 4.84144 32.5173 5.28421V31.7158C32.5173 32.1585 32.1584 32.5174 31.7157 32.5174ZM6.08576 30.9141H30.914V6.08588H6.08576V30.9141Z",
    fill: "#F29550"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3704 26.3181C15.1391 26.3181 14.9183 26.2182 14.766 26.0431L10.2237 20.8242C9.9332 20.49 9.96835 19.9837 10.302 19.6932C10.6362 19.4022 11.1425 19.4379 11.4329 19.7716L15.3321 24.2516L25.5361 10.9952C25.8062 10.6443 26.3094 10.5789 26.6603 10.849C27.0112 11.1191 27.0765 11.6223 26.8064 11.9732L16.0049 26.0054C15.8581 26.196 15.6343 26.3107 15.3938 26.3175C15.3858 26.3175 15.3778 26.3175 15.3697 26.3175L15.3704 26.3181Z",
    fill: "#F29550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.af4229a915585445e9c8754c125941e6.svg";
export { ForwardRef as ReactComponent };